import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Backdrop,
  Button,
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Divider,
  Link,
  Modal,
  Tabs,
  Tab,
  Typography, Collapse,
} from '@material-ui/core';
import {
  Bookmark,
  Close, ExpandLess, ExpandMore,
  OpenInNew,
} from '@material-ui/icons';
import qs from 'qs';
import AdminNewTitleContainer from '../../../containers/admin/titles/AdminNewTitleContainer';
import moment from 'moment';
import _ from 'lodash';
import ContactHeader from "./acordionSections/ContactHeader";
import ContactInfo from "./acordionSections/ContactInfo";
import PrivateBio from "./acordionSections/PrivateBio";
import General from "./acordionSections/General";
import Disclosures from "./acordionSections/Disclosures";
import EducationSection from "./acordionSections/EducationSection";
import axios from "axios";
import DesignationsContainer from '../../../containers/admin/contacts/accordionSections/DesignationsContainer';
import RegistrationsContainer from '../../../containers/admin/contacts/accordionSections/RegistrationsContainer';
import CompanyInfoContainer from '../../../containers/admin/contacts/accordionSections/CompanyInfoContainer';
import OwnerExecutiveOfficerContainer from '../../../containers/admin/contacts/accordionSections/OwnerExecutiveOfficerContainer';
import EmploymentContainer from '../../../containers/admin/contacts/accordionSections/EmploymentContainer';
import CustomSnackbar from '../../user/shared/CustomSnackbar';
import CurrentCompanyData from './acordionSections/CurrentCompanyData';
import ContactsAccoladesSectionContainer from "../../../containers/admin/contacts/ContactsAccoladesSectionContainer";
import ChangeLogModal from "../shared/ChangeLogModal";
import useEffectExceptOnMount from "../../../helpers/useEffectExceptOnMount";
import ContactsForbesAumsSectionContainer from "../../../containers/admin/contacts/ContactsForbesAumsSectionContainer";
import IndustryTenure from "./acordionSections/IndustryTenure";
import TasksQueueSidebar from "../tasks/tasksQueue/TasksQueueSidebar";
import useSnackbar from "../../../hooks/useSnackbar";
import useAdminNotes from "../../../hooks/useAdminNotes";
import NotesDialog from "../shared/Dialogs/NotesDialog";
import LinkedinSyncConfirmDialog from "../shared/Dialogs/LinkedinSyncConfirmDialog";
import LinkedinUnsyncWarningDialog from "../shared/Dialogs/LinkedinUnsyncWarningDialog";
import RiaContactService from "../services/RiaContactService";
import {useLinkedinCrossDatasetConfirm} from "../../../hooks/useLinkedinCrossDatasetConfirm";
import InvestmentCommitteeMember from "./acordionSections/InvestmentCommitteeMember";
import { toCustomTitleCase } from "../../../helpers/utils";
import AiDentifiedData from "./acordionSections/AiDentifiedData";
import HideEntity from "../shared/Buttons/HideEntity";
import WarningsSection from "./acordionSections/WarningsSection";
import DataIntegrityWarningsSection from "../dataIntegrity/shared/DataIntegrityWarningsSection";
import DataIntegrityService from "../services/DataIntegrityService";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: '96%',
    height: '96%',
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
    background: '#F1F3F4',
  },
  contentSection: {
    padding: '16px 22px',
    background: '#eeeeee',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  cardHeaderContainer: {
    background: '#fff',
    borderRadius: '3px',
    paddingBottom: '0px',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
    position: 'relative',
  },
  modalHeaderDivider: {
    margin: '0 -24px',
  },
  cardHeaderTitle: {
    fontWeight: '700',
    fontSize: '18px',
  },
  cardContent: {
    padding: '15px 26px',
    overflow: 'auto',
    height: 'calc(100% - 158px)',
  },
  buttonLabel: {
    textTransform: 'capitalize',
  },
  form: {
    height: '100%',
  },
  tab: {
    textTransform: 'capitalize',
    fontWeight: '600',
    color: '#7A7A7A',
  },
  tabSelected: {
    textTransform: 'capitalize',
    fontWeight: '600',
    color: '#000',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  fromOtherModal: {
    position: 'absolute',
    top: '-24px',
    left: '-6px',
    color: 'blue',
  },
  movedCompany: {
    position: 'absolute',
    top: '-24px',
    left: '20px',
    color: 'red',
  },
  contactPhoto: {
    width: '35px',
    height: '35px',
  },
  buttonMarginRight: {
    marginRight: 10,
  },
  modalButtonsContainer: {
    display: 'flex',
  },
  linkWithIcon: {
    display: 'flex',
    marginLeft: 10,
  },
  contactTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  widthCardHeader: {
    width: '100%',
  }
}));

const EditContactModalRebuild = (props) => {
  const classes = useStyles();

  const [contact, setContact] = useState({})
  const [tab, setTab] = useState(0)
  const [status, setStatus] = useState('fetching')
  const [statusRelationships, setStatusRelationships] = useState('fetching')
  const [currentCompanyDataStatus, setCurrentCompanyDataStatus] = useState('fetching')
  const [relationships, setRelationships] = useState({})
  const [openNewTitleModal, setOpenNewTitleModal] = useState(false)
  const [openTitleAutocomplete, setOpenTitleAutocomplete] = useState(false)
  const [openAutomatedTitleAutocomplete, setOpenAutomatedTitleAutocomplete] = useState(false)
  const [openAchievementsAutocomplete, setOpenAchievementsAutocomplete] = useState(false)
  const [educationHistory, setEducationHistory] = useState([])
  const [employmentHistory, setEmploymentHistory] = useState([])
  const [currentCompanyData, setCurrentCompanyData] = useState([])
  const [employmentHistoryBrokerDealer, setEmploymentHistoryBrokerDealer] = useState([])
  const [workAround, setWorkAround] = useState(new Date())
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [potentialLinkedinUrl, setPotentialLinkedinUrl] = useState(null);

  const [fileFirstNameChanged, setFileFirstNameChanged] = useState(false)
  const [fileLastNameChanged, setFileLastNameChanged] = useState(false)
  const [fileFirstNameOtherChanged, setFileFirstNameOtherChanged] = useState(false)

  const [disclosureData, setDisclosureData] = useState({});
  const [disclosureBrokerDealerData, setDisclosureBrokerDealerData] = useState({});
  const [emailValidations, setEmailValidations] = useState({});
  const [pastEmails, setPastEmails] = useState([]);
  const [changes, setChanges] = useState();
  const [openChanges, setOpenChanges] = useState(false)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [saving, setSaving] = useState(false)
  const [hasFieldChanges, setHasFieldChanges] = useState(false)
  const [isHidden, setIsHidden] = useState(null);
  const [investorsForDomain, setInvestorsForDomain] = useState([]);
  const [investorsForDomainEmailField, setInvestorsForDomainEmailField] = useState('email');
  const [warnings, setWarnings] = useState([]);
  const [fetchingWarnings, setFetchingWarnings] = useState(true);
  const [diWarnings, setDiWarnings] = useState([]);
  const [fetchingDiWarnings, setFetchingDiWarnings] = useState(true);
  const [diCurrentCount, setDiCurrentCount] = useState(0);
  const [diTotalUniqueCount, setDiTotalUniqueCount] = useState(0);
  const [fetchingUpdateCounts, setFetchingUpdateCounts] = useState(true);
  const [updatesAllTimeCount, setUpdatesAllTimeCount] = useState(0);
  const [updatesLast30DaysCount, setUpdatesLast30DaysCount] = useState(0);
  const [validationsInProgress, setValidationsInProgress] = useState(0);
  const [fieldErrors, setFieldErrors] = useState({});

  const snackbar = useSnackbar();
  const adminNotes = useAdminNotes(contact?.id, "RiaContact", snackbar, RiaContactService.notes);
  const originalLinkedinUrl = useRef(null);
  const {confirmLinkedinChange, linkedinConfirmDialogProps, linkedinUnsyncWarningDialogProps} = useLinkedinCrossDatasetConfirm('RiaContact');

  const isOnlyResearcher = props.adminUserSession.isResearcher && !props.adminUserSession.inHouseResearch && !props.adminUserSession.isSuperAdmin

  const handleFieldError = (fieldName, hasError) => {
    setFieldErrors(prev => {
      if (prev[fieldName] === hasError) return prev;
      return { ...prev, [fieldName]: hasError };
    });
  };
  const hasValidationErrors = Object.values(fieldErrors).some(Boolean);

  useEffectExceptOnMount(() => {
    if (props.triggerSave > 0) {
      handleSubmit(null)
    }
  }, [props.triggerSave])

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/edit`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        contact,
        disclosure,
        disclosure_broker_dealer,
        has_bad_emails,
        email_validation_data,
        secondary_email_validation_data,
        automated_email_validation_data,
        is_hidden,
        status,
      } = response.data;

      setDisclosureData(disclosure);
      setDisclosureBrokerDealerData(disclosure_broker_dealer);
      setEmailValidations({
        email: email_validation_data,
        secondary_email: secondary_email_validation_data,
        automated_email: automated_email_validation_data,
      });

      setContact({
        contactFirstName: toCustomTitleCase(contact.contact_first_name),
        contactLastName: toCustomTitleCase(contact.contact_last_name),
        lastEdited: contact.latest_update,
        lastReviewed: contact.last_reviewed,
        createdAt: contact.created_at,
        crdId: contact.contact_crd_id,
        email: contact.email || '',
        current_companies: contact.current_companies || '',
        researcher: contact.researcher_name,
        mobile_phone_number: contact.mobile_phone_number || '',
        additional_phone_number: contact.additional_phone_number || '',
        office_phone_number: contact.office_phone_number || '',
        ext_additional_phone_number: contact.ext_additional_phone_number || '',
        ext_office_phone_number: contact.ext_office_phone_number || '',
        country_prefix_office_phone_number: contact.country_prefix_office_phone_number || '',
        country_prefix_mobile_phone_number: contact.country_prefix_mobile_phone_number || '',
        country_prefix_additional_phone_number: contact.country_prefix_additional_phone_number || '',
        linkedinProfileUrl: contact.linkedin_profile_url || '',
        datasets: contact.datasets || [],
        datasetContactNames: contact.dataset_contact_names || {},
        privateBio: contact.ria_private_bio || '',
        industryTenure: contact.industry_tenure || {},
        achievementsIds: contact.achievement_ids,
        titleId: contact.title_id,
        titleOptions: contact.selected_title ? [contact.selected_title] : [],
        achievementsOptions: contact.achievements || [],
        titleDefault: contact.selected_title || '',
        automated_title_name: contact.automated_title_name,
        automated_email: contact.automated_email || '',
        automated_phone: contact.automated_phone || '',
        automated_source: contact.automated_source || '',
        automated_linkedin: contact.automated_linkedin || '',
        achievementsDefault: contact.achievements || [],
        secondary_email: contact.secondary_email || '',
        gender: contact.gender || '',
        personal_email: contact.personal_email || '',
        personal_email_source: contact.personal_email_source || '',
        personal_email_modified_date: contact.personal_email_modified_date || '',
        dob_month: contact.dob_month || '',
        dob_day: contact.dob_day || '',
        dob_year: contact.dob_year || '',
        dob_source: contact.dob_source || '',
        dob_modified_date: contact.dob_modified_date || '',
        photo: contact.photo_url || '',
        photo_url: contact.photo_url || '',
        photoPreview: contact.photo_url || '',
        contact_bio_url: contact.contact_bio_url || '',
        contact_has_disclosed_bankrupt: contact.contact_has_disclosed_bankrupt,
        contact_has_disclosed_bond: contact.contact_has_disclosed_bond,
        contact_has_disclosed_civil_event: contact.contact_has_disclosed_civil_event,
        contact_has_disclosed_criminal: contact.contact_has_disclosed_criminal,
        contact_has_disclosed_customer_dispute: contact.contact_has_disclosed_customer_dispute,
        contact_has_disclosed_investigation: contact.contact_has_disclosed_investigation,
        contact_has_disclosed_judgment_or_lien: contact.contact_has_disclosed_judgment_or_lien,
        contact_has_disclosed_regulatory_event: contact.contact_has_disclosed_regulatory_event,
        contact_has_disclosed_termination: contact.contact_has_disclosed_termination,
        contact_has_reported_professional_designation: contact.contact_has_reported_professional_designation,
        contact_actv_ag_reg_tbd: contact.contact_actv_ag_reg_tbd,
        contact_has_reported_professional_designation_db: contact.contact_has_reported_professional_designation_db,
        contact_actv_ag_reg_tbd_db: contact.contact_actv_ag_reg_tbd_db,
        contact_crd_id: contact.contact_crd_id,
        contact_link: contact.contact_link,
        contact_link_broker_dealer: contact.contact_link_broker_dealer,
        contact_first_name: contact.contact_first_name,
        contact_last_name: contact.contact_last_name,
        contact_middle_name: contact.contact_middle_name,
        contact_surffix_name: contact.contact_surffix_name,
        contact_first_name_other: contact.contact_first_name_other,
        contact_first_name_other_source: contact.contact_first_name_other_source,
        contact_first_name_other_source_email: contact.contact_first_name_other_source_email,
        contact_last_name_other: contact.contact_last_name_other,
        contact_middle_name_other: contact.contact_middle_name_other,
        contact_surffix_name_other: contact.contact_surffix_name_other,
        contact_first_name_other_bd: contact.contact_first_name_other_bd,
        contact_last_name_other_bd: contact.contact_last_name_other_bd,
        contact_middle_name_other_bd: contact.contact_middle_name_other_bd,
        contact_surffix_name_other_bd: contact.contact_surffix_name_other_bd,
        other_business_activities: contact.other_business_activities,
        is_registered: contact.is_registered,
        isOwner: contact.is_owner,
        isActive: contact.active,
        entityType: contact.type_entity,
        moved: contact.moved,
        id: contact.id,
        aiDentifiedData: contact.aiDentifiedData || {},
        has_bad_emails,
        file_first_name: contact.file_first_name || '',
        file_last_name: contact.file_last_name || '',
        file_first_name_other: contact.file_first_name_other || '',
        archived_first_name: contact.archived_first_name,
        archived_last_name: contact.archived_last_name,
        archived_first_name_other: contact.archived_first_name_other,
        main_office_country_iso: contact.main_office_country_iso || 'US'
      })
      originalLinkedinUrl.current = contact.linkedin_profile_url || '';
      setStatus(status)
      setIsHidden(is_hidden);

      fetchWarnings(contact.contact_crd_id)
      fetchDiWarnings(contact.contact_crd_id)
      fetchUpdateCounts(contact.contact_crd_id)
    });

    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/relationships`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { relationships, status } = response.data;

      let educationHistory = relationships.education_history || [];

      setRelationships({
        registeredEmploymentHistory: relationships.ria_registered_employment_history || [],
      })

      setEducationHistory([...educationHistory]);
      setStatusRelationships(status)
    });

    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/current_companies_data`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { current_companies_data, status: currentCompanyStatus } = response.data;

      setCurrentCompanyData(current_companies_data);
      setCurrentCompanyDataStatus(currentCompanyStatus);
    });
  }, [])

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/past_emails`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { past_emails, status: newStatus } = response.data;

      setPastEmails(past_emails)
    });
  }, [])

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/get_potential_linkedin_url`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { potential_linkedin_url, status: newStatus } = response.data;

      setPotentialLinkedinUrl(potential_linkedin_url)
    });
  }, [])


  useEffectExceptOnMount(() => {
    if (props.adminUpdateItemWithFiles) {
      const {
        status: statusUpdate,
        message,
        contact: contactData,
      } = props.adminUpdateItemWithFiles;

      if (![null, undefined].includes(statusUpdate) && statusUpdate !== 'updating') {
        if (statusUpdate === 'updated') {
          if (!!props.handleAfterSave) {
            props.handleAfterSave()
          }
          props.handleResetUpdatingItemWithFiles();
          props.onClose();
        } else {
          if (message.constructor.name === 'Array') {
            setSnackBarMessage(message?.join(', '));
          } else {
            setSnackBarMessage(message);
          }
          setShowSnackBar(true);
          props.handleResetUpdatingItemWithFiles();
        }
      }
    }
  }, [props.adminUpdateItemWithFiles]);

  const openChangeLogs = () => {
    axios.get(
      `/v1/admin/ria_contacts/${props.contactId}/changes_log`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { changes } = response.data;
      setOpenChanges(true)
      setChanges(changes);
    });
  }

  const newNestedFieldsEmployment = (otherId) => ({
    id: otherId,
    attributes: {
      from_file: false,
      contact_employment_history_company_name: '',
      contact_employment_history_start_date: new Date(),
      contact_employment_history_end_date: null,
      contact_employment_history_location_city: '',
      contact_employment_history_location_state: '',
    },
    _destroy: false,
  })

  const newNestedFieldsEducation = (otherId) => ({
    id: otherId,
    attributes: {
      university_id: '',
      start_year: '',
      end_year: '',
    },
    _destroy: false,
  })

  const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase())
  }

  const  handleContactFieldChange = (event) => {
    const newContact = Object.assign(contact);

    if (event.target.name === 'file_first_name')
      setFileFirstNameChanged(contact.file_first_name !== event.target.value)
    if (event.target.name === 'file_last_name')
      setFileLastNameChanged(contact.file_last_name !== event.target.value)
    if (event.target.name === 'file_first_name_other')
      setFileFirstNameOtherChanged(contact.file_first_name_other !== event.target.value)

    newContact[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    setContact(newContact);
  };

  const handleAiDentifiedFieldChange = (event) => {
    const newContact = Object.assign({}, contact);

    if (!newContact.aiDentifiedData) {
      newContact.aiDentifiedData = {};
    }

    newContact.aiDentifiedData[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    setContact(newContact);
  };

  const handleTabChange = (event, newValue) => {
    event.preventDefault();

    if (tab === newValue) {
      newValue = false
    }
    setTab(newValue)
  }

  const handleRemovePhoto = (event) => {
    event.preventDefault();

    if (window.confirm("Are you sure?")) {
      props.handleDeleteRiaContactPhoto(props.adminUserSession, `/v1/admin/ria_contacts/${props.contactId}/remove_photo`)
        .then(() => {
          if (props.deletedRiaContactPhoto.status === 'ok') {
            const newContact = Object.assign({}, contact);
            newContact["photoPreview"] = '';
            newContact["photo"] = '';
            setContact(newContact);
          }
        })
    }
  }

  const handleSubmit = async (event) => {
    setSaving(true)
    event?.preventDefault();
    event?.stopPropagation();

    if (hasUnsavedChanges) {
      setSnackBarMessage('You have unsaved changes in FINTRX Native Data section. Please Save or Cancel them before saving the contact.')
      setShowSnackBar(true)
      return
    }

    if (hasFieldChanges) {
      setSnackBarMessage('Cannot save because there are fields in edit mode that need to be validated first.')
      setShowSnackBar(true)
      setSaving(false)
      return
    }

    if (hasValidationErrors) {
      setSnackBarMessage('Cannot save because some fields have validation errors. Please fix them before saving.')
      setShowSnackBar(true)
      setSaving(false)
      return
    }

    const {
      email,
      mobile_phone_number,
      additional_phone_number,
      ext_additional_phone_number,
      linkedinProfileUrl,
      datasets,
      datasetContactNames,
      privateBio,
      titleId,
      achievementsIds,
      secondary_email,
      gender,
      personal_email,
      dob_month,
      dob_day,
      dob_year,
      office_phone_number,
      ext_office_phone_number,
      photo,
      contact_bio_url,
      file_first_name,
      file_last_name,
      file_first_name_other,
      country_prefix_office_phone_number,
      country_prefix_mobile_phone_number,
      country_prefix_additional_phone_number,
    } = contact;

    let employmentHistoryFiltered = employmentHistory.filter((item) => !item.attributes.from_file);
    let employmentHistoryBrokerDealerFiltered = employmentHistoryBrokerDealer.filter((item) => !item.attributes.from_file);

    employmentHistoryFiltered = employmentHistoryFiltered.map((item) => {
      const {
        contact_employment_history_company_name,
        contact_employment_history_start_date,
        contact_employment_history_end_date,
        contact_employment_history_location_city,
        contact_employment_history_location_state,
      } = item.attributes;

      const itemId = item.id.includes('employment') ? null : item.id;
      const startDate = contact_employment_history_start_date ? moment(contact_employment_history_start_date).format('YYYY-MM-DD') : '';
      const endDate = contact_employment_history_end_date ? moment(contact_employment_history_end_date).format('YYYY-MM-DD') : '';

      return (
        {
          id: itemId,
          contact_employment_history_company_name,
          contact_employment_history_start_date: startDate,
          contact_employment_history_end_date: endDate,
          contact_employment_history_location_city,
          contact_employment_history_location_state,
          _destroy: item._destroy,
        }
      )
    });

    employmentHistoryBrokerDealerFiltered = employmentHistoryBrokerDealerFiltered.map((item) => {
      const {
        contact_employment_history_company_name,
        contact_employment_history_start_date,
        contact_employment_history_end_date,
        contact_employment_history_location_city,
        contact_employment_history_location_state,
      } = item.attributes;

      const itemId = item.id.includes('employment') ? null : item.id;
      const startDate = contact_employment_history_start_date ? moment(contact_employment_history_start_date).format('YYYY-MM-DD') : '';
      const endDate = contact_employment_history_end_date ? moment(contact_employment_history_end_date).format('YYYY-MM-DD') : '';

      return (
        {
          id: itemId,
          contact_employment_history_company_name,
          contact_employment_history_start_date: startDate,
          contact_employment_history_end_date: endDate,
          contact_employment_history_location_city,
          contact_employment_history_location_state,
          _destroy: item._destroy,
        }
      )
    });

    const educationHistoryFormatted = educationHistory.map((item) => {
      const {
        university_id,
        start_year,
        end_year
      } = item.attributes;

      const itemId = item.id.includes('education') ? null : item.id;
      const startDate = start_year;
      const endDate = end_year;

      return (
        {
          id: itemId,
          university_id: university_id,
          start_year: startDate,
          end_year: endDate,
          _destroy: item._destroy,
        }
      )
    });

    const currentCompanyDataParams = currentCompanyData.map((item) => {
      const {
        id,
        phone,
        phone_ext,
        email,
        title_id,
        personal_team_page,
        primary_firm,
        primary_ria,
        primary_bd,
      } = item;

      return (
        {
          id,
          phone,
          phone_ext,
          email,
          title_id,
          personal_team_page,
          primary_firm,
          primary_ria,
          primary_bd,
        }
      )
    });

    const doublePrimaryFirm = currentCompanyDataParams.filter((item) => item.primary_firm).length > 1;
    if (doublePrimaryFirm) {
      setSnackBarMessage('Cannot have more than one Primary Firm.')
      setShowSnackBar(true)
      setSaving(false)
      return;
    }

    const doublePrimaryRia = currentCompanyDataParams.filter((item) => item.primary_ria).length > 1;
    if (doublePrimaryRia) {
      setSnackBarMessage('Cannot have more than one Primary Ria.')
      setShowSnackBar(true)
      setSaving(false)
      return;
    }

    const doublePrimaryBD = currentCompanyDataParams.filter((item) => item.primary_bd).length > 1;
    if (doublePrimaryBD) {
      setSnackBarMessage('Cannot have more than one Primary BD.')
      setShowSnackBar(true)
      setSaving(false)
      return;
    }

    const doublePrimaryRiaBd = currentCompanyDataParams.filter((item) => item.primary_ria && item.primary_bd).length > 0;
    if (doublePrimaryRiaBd) {
      setSnackBarMessage('A company can\'t be Primary Ria and Primary BD.')
      setShowSnackBar(true)
      setSaving(false)
      return;
    }

    let params = {
      email: email,
      mobile_phone_number: mobile_phone_number,
      additional_phone_number: additional_phone_number,
      ext_additional_phone_number: ext_additional_phone_number,
      linkedin_profile_url: linkedinProfileUrl,
      private_bio: privateBio,
      secondary_email: secondary_email,
      gender: gender,
      personal_email: personal_email,
      dob_month: dob_month,
      dob_day: dob_day,
      dob_year: dob_year,
      office_phone_number: office_phone_number,
      ext_office_phone_number: ext_office_phone_number,
      contact_employment_histories_attributes: employmentHistoryFiltered,
      contact_employment_history_broker_dealers_attributes: employmentHistoryBrokerDealerFiltered,
      ria_contact_universities_attributes: educationHistoryFormatted,
      ria_contact_current_company_data_attributes: currentCompanyDataParams,
      title_id: titleId,
      automated_title_id: contact.automated_title_id,
      automated_phone: contact.automated_phone,
      automated_email: contact.automated_email,
      achievement_ids: achievementsIds,
      contact_bio_url: contact_bio_url,
      file_first_name: file_first_name,
      file_last_name: file_last_name,
      file_first_name_other: file_first_name_other,
      file_first_name_changed: fileFirstNameChanged,
      file_last_name_changed: fileLastNameChanged,
      file_first_name_other_changed: fileFirstNameOtherChanged,
      country_prefix_office_phone_number: country_prefix_office_phone_number,
      country_prefix_mobile_phone_number: country_prefix_mobile_phone_number,
      country_prefix_additional_phone_number: country_prefix_additional_phone_number,
      investors_for_domain: investorsForDomain,
      investors_for_domain_email_field: investorsForDomainEmailField,
    }

    if (photo != contact.photo_url) {
      params = _.merge(params, { photo: photo })
    }

    params.ria_contact_ai_dentified_datum_attributes = {
      contact_crd_id: contact.contact_crd_id,
      ...contact.aiDentifiedData
    }

    // If in the modified warnings, any is rejected and there's no other pending record in all warnings, send empty email
    const hasRejectedWarning = warnings.filter((warning) => warning.modified && warning.status === 'ignored' && warning.type_of_warning === 'allowed_domain').length > 0;
    const hasApprovedWarning = warnings.filter((warning) => warning.modified && warning.status === 'resolved' && warning.type_of_warning === 'allowed_domain').length > 0;
    const hasPendingWarning = warnings.filter((warning) => warning.status === 'pending' && warning.type_of_warning === 'allowed_domain').length > 0;

    if (hasRejectedWarning && !hasPendingWarning && !hasApprovedWarning) {
      params.email = '';
    }

    const linkedinAction = await confirmLinkedinChange(datasets, originalLinkedinUrl.current, linkedinProfileUrl, datasetContactNames);
    if (linkedinAction === 'abort') {
      setSaving(false);
      return;
    }
    if (linkedinAction) {
      params.unsync_person = linkedinAction === 'unsync';
    }

    updateWarnings().then(() => {
      const warningsWereModified = warnings.some(w => w.modified);

      props.handleProcessItemWithFiles(props.adminUserSession, `/v1/admin/ria_contacts/${props.contactId}`, { ria_contact: params }).then(() => {
        if (props.onWarningsUpdate && warningsWereModified) {
          props.onWarningsUpdate();
        }
        setSaving(false)
      })
    })
  }

  const handleOpenSnackBar = (message) => {
    setSnackBarMessage(message);
    setShowSnackBar(true);
  }

  const handleCloseSnackBar = () => {
    setSnackBarMessage('');
    setShowSnackBar(false);
  }

  const verifyFieldsChanged = () => {
    const {
      email,
      mobile_phone_number,
      additional_phone_number,
      ext_additional_phone_number,
      linkedinProfileUrl,
      titleId,
      achievementsIds,
      secondary_email,
      gender,
      office_phone_number,
      ext_office_phone_number,
      photo,
      contact_bio_url
    } = contact;

    if (contact.email !== email || contact.mobile_phone_number !== mobile_phone_number
      || contact.additional_phone_number !== additional_phone_number || contact.office_phone_number !== office_phone_number
      || contact.ext_additional_phone_number !== ext_additional_phone_number || contact.ext_office_phone_number !== ext_office_phone_number
      || contact.linkedin_profile_url !== linkedinProfileUrl || !_.isEqual(contact.achievement_ids, achievementsIds)
      || contact.title_id !== titleId || contact.secondary_email !== secondary_email
      || contact.gender !== gender || contact.photo_url !== photo || contact.contact_bio_url !== contact_bio_url) {
    }
  }

  const markasReviewed = (event) => {
    axios.put(
      `/v1/admin/ria_contacts/${props.contactId}/mark_as_reviewed`,
      qs.stringify({ ria_contact: { from_title: false } }),
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const {
        status: statusUpdate,
        message,
        contact: contactData,
      } = response.data;

      if (statusUpdate === 'marked') {
        props.onClose();
      } else {
        if (message.constructor.name === 'Array') {
          setSnackBarMessage(message?.join(', '));
        } else {
          setSnackBarMessage(message);
        }
        setShowSnackBar(true);
      }
    });
  }

  const handleCompanyDataChange = (event, item) => {
    item[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setWorkAround(new Date());
  }

  const handleNestedFieldChange = (event, item, nestedFieldsName) => {
    item.attributes[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setWorkAround(new Date());
  }

  const handleAddNestedFields = (type, nestedFieldsName) => {
    const otherId = Date.now();

    let newField = {}

    switch (nestedFieldsName) {
      case 'educationHistory': {
        newField = Object.assign({}, newNestedFieldsEducation(`${type}_${otherId}`));
        setEducationHistory([...educationHistory, newField]);
      }
        break;
      case 'employmentHistory':
        {
          newField = Object.assign({}, newNestedFieldsEmployment(`${type}_${otherId}`));

          setEmploymentHistory([...employmentHistory, newField]);
        }
        break;
      case 'employmentHistoryBrokerDealer':
        {
          newField = Object.assign({}, newNestedFieldsEmployment(`${type}_${otherId}`));

          setEmploymentHistoryBrokerDealer([...employmentHistoryBrokerDealer, newField]);
        }
        break;
    }
  }

  const handleRemoveNestedFields = (nestedField, nestedFieldsName) => {
    nestedField._destroy = true;
    setWorkAround(new Date());
  }

  const handleOnChangeAutocomplete = (event, field, selectedValue) => {
    let originalSelected = null;

    if (selectedValue && selectedValue.constructor && selectedValue.constructor.name === 'Array') {
      originalSelected = [...selectedValue];
    } else {
      originalSelected = selectedValue;
    }

    switch (selectedValue && selectedValue.constructor && selectedValue.constructor.name) {
      case 'Array':
        selectedValue = (selectedValue.map((values) => values.id));
        break;
      default:
        selectedValue = selectedValue ? selectedValue.id : null;
        break;
    }

    let fieldName = '';

    switch (field) {
      case 'titleId':
        fieldName = 'titleDefault';
        break;
      case 'automated_title_id':
        fieldName = 'automatedTitle';
        break;
      case 'achievementsIds':
        fieldName = 'achievementsDefault'
        break;
      default:
        break;
    }

    setContact({
      ...contact,
      [field]: selectedValue,
      [fieldName]: originalSelected,
    })
  }

  const handleInputChangeAutocomplete = (event, itemType) => {
    event.persist();
    debounceFilterInput(event, itemType);
  }

  const debounceFilterInput = _.debounce((event, itemType) => {
    switch (itemType) {
      case 'titles':
        if (event.target.value !== '' && event.target.value.length < 3) {
          return
        }
        axios.get(
          `/v1/admin/titles/filter`,
          {
            params: { filter: event.target.value },
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-Admin-User-Email': props.adminUserSession.email,
              'X-Admin-User-Token': props.adminUserSession.token
            }
          }
        ).then((response) => {
          const { status, titles } = response.data;

          if (status === 'ok') {
            setContact({
              ...contact,
              titleOptions: titles,
            });
          }
        });

        break;
      case 'achievements':
        axios.get(
          `/v1/admin/achievements/filter`,
          {
            params: { filter: event.target.value },
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-Admin-User-Email': props.adminUserSession.email,
              'X-Admin-User-Token': props.adminUserSession.token
            }
          }
        ).then((response) => {
          const { status, achievements } = response.data;

          if (status === 'ok') {
            setContact({
              ...contact,
              achievementsOptions: achievements,
            });
          }
        });
      default:
        break;
    }
  }, 650)

  const hadleOpen = (event, stateVar, open) => {
    switch (stateVar) {
      case 'openTitleAutocomplete':
        if (open === true) {
          axios.get(
            `/v1/admin/titles/filter`,
            {
              params: { ids: contact.titleId },
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-Admin-User-Email': props.adminUserSession.email,
                'X-Admin-User-Token': props.adminUserSession.token
              }
            }
          ).then((response) => {
            const { status, titles } = response.data;

            if (status === 'ok') {
              if (open === true) {
                setContact({
                  ...contact,
                  titleOptions: titles,
                });
              }
              setOpenTitleAutocomplete(open)
            }
          });
        } else {
          setOpenTitleAutocomplete(false)
        }

        break;
      case 'openAutomatedTitleAutocomplete':
        if (open === true) {
          axios.get(
            `/v1/admin/titles/filter`,
            {
              params: { ids: contact.automated_title_id },
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-Admin-User-Email': props.adminUserSession.email,
                'X-Admin-User-Token': props.adminUserSession.token
              }
            }
          ).then((response) => {
            const { status, titles } = response.data;

            if (status === 'ok') {
              if (open === true) {
                setContact({
                  ...contact,
                  titleOptions: titles,
                });
              }
              setOpenAutomatedTitleAutocomplete(open)
            }
          });
        } else {
          setOpenAutomatedTitleAutocomplete(false)
        }

        break;
      case 'openAchievementsAutocomplete':
        if (open === true) {
          axios.get(
            `/v1/admin/achievements/filter`,
            {
              params: { ids: contact.achievementsIds },
              headers: {
                'Content-Type': 'multipart/form-data',
                'X-Admin-User-Email': props.adminUserSession.email,
                'X-Admin-User-Token': props.adminUserSession.token
              }
            }
          ).then((response) => {
            const { status, achievements } = response.data;

            if (status === 'ok') {
              if (open === true) {
                setContact({
                  ...contact,
                  achievementsOptions: achievements,
                });
              }
              setOpenAchievementsAutocomplete(open)
            }
          });
        } else {
          setOpenAchievementsAutocomplete(false)
        }

      default:
        break;
    }
  }

  const fetchWarnings = async (crdId) => {
    setFetchingWarnings(true);
    const { data: { warnings: contactWarnings } } = await RiaContactService.warnings(crdId, props.adminUserSession);
    setWarnings(contactWarnings);
    setFetchingWarnings(false);
  }

  const fetchDiWarnings = async (crdId) => {
    setFetchingDiWarnings(true);
    const response = await DataIntegrityService.getRecordWarnings(crdId, 'contact', props.adminUserSession, { per_page: 100 });
    setDiWarnings(response?.data?.warnings || []);
    setDiCurrentCount(response?.data?.current_count || 0);
    setDiTotalUniqueCount(response?.data?.total_unique_count || 0);
    setFetchingDiWarnings(false);
  }

  const fetchUpdateCounts = async (crdId) => {
    setFetchingUpdateCounts(true);
    const response = await DataIntegrityService.getRecordUpdateCounts(crdId, 'contact', props.adminUserSession);
    setUpdatesAllTimeCount(response?.data?.all_time?.aggregate_count || 0);
    setUpdatesLast30DaysCount(response?.data?.last_30_days?.aggregate_count || 0);
    setFetchingUpdateCounts(false);
  }

  const updateWarnings = () => {
    return Promise.all(warnings.filter((warning) => warning.modified).map((warning) => {
      return RiaContactService.updateWarning(warning.id, props.adminUserSession, { status: warning.status });
    }))
  }

  const handleChangeFileInput = (event) => {
    event.persist();
    const newContact = Object.assign(contact)
    newContact['photo'] = event.target.files[0]
    newContact['photoPreview'] = event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : contact.photoPreview
    setContact(newContact)
  }

  const closeModal = () => {
    verifyFieldsChanged();
    props.onClose();
  }

  const onOpenNotes = () => adminNotes.setOpen(true);

  const handleOpenNewTitleModal = () => {
    setOpenNewTitleModal(true)
  }

  const handleCloseNewTitleModal = (title) => {
    setOpenNewTitleModal(false)
    const newContact = Object.assign(contact)
    newContact["titleId"] = title.id
    newContact["titleDefault"] = { id: title.id, name: title.name }
    newContact["titleOptions"] = [{ id: title.id, name: title.name }]
    setContact(newContact)
  }

  const onRegenerateAiBio = async () => {
    await RiaContactService.regenerateAiBio(props.contactId, props.adminUserSession).then((response) => {
      const { status, message } = response.data

      if (status === 'ok') {
        alert(message)
      } else {
        setSnackBarMessage(message);
        setShowSnackBar(true)
        console.log('message', message)
      }
    }).catch(function (thrown) {
      console.log('Request canceled', thrown.message);
    });
  }

  const { fromInvestorModal } = props;
  const deletePhotoStatus = props && props.deletedRiaContactPhoto ? props.deletedRiaContactPhoto.status : '';
  const {
    achievementsOptions,
    isActive
  } = contact;

  const loadingAchievements = openAchievementsAutocomplete && achievementsOptions.length === 0;

  const {
    entityType
  } = contact;

  return (
    <>
      <Modal
        onClose={closeModal}
        open={props.open}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <Card
          className={clsx(classes.root, props.className)}
          style={props.queueSidebar ? { display: 'flex' } : {}}
        >
          <form onSubmit={handleSubmit} className={clsx(classes.form, { ['tasks-queue-form']: props.queueSidebar })}>
            {
              (status && status === 'updating' || status && status !== 'fetched' ||
                statusRelationships && statusRelationships === 'updating' || statusRelationships && statusRelationships !== 'fetched_relationships' ||
                deletePhotoStatus && deletePhotoStatus === 'deleting_photo') ?

                (<Backdrop className={classes.backdrop} open={status && status === 'updating' || status && status !== 'fetched' ||
                  statusRelationships && statusRelationships === 'updating' || statusRelationships && statusRelationships !== 'fetched_relationship' ||
                  deletePhotoStatus && deletePhotoStatus === 'deleting_photo'}>
                  <CircularProgress />
                </Backdrop>) :

                <React.Fragment>
                  <CardHeader className={classes.cardHeaderContainer} classes={{ content: classes.widthCardHeader }}
                    title={
                      <div>
                        <div className={classes.cardHeader}>
                          {fromInvestorModal ? <span className={classes.fromOtherModal}><Bookmark fontSize='large' /></span> : ''}
                          {contact?.moved === true ? <span className={classes.movedCompany}><Bookmark fontSize='large' /></span> : ''}
                          <div className={classes.contactTitleContainer}>
                            <Typography variant="h5" className={classes.cardHeaderTitle}>{`${contact ? contact.contact_first_name_other || toCustomTitleCase(contact.contact_first_name) : ''} ${contact ? toCustomTitleCase(contact.contact_last_name) : ''} ${contact.contact_surffix_name || ''} ${contact ? ', ' + capitalize(contact.current_companies) : ''}`}</Typography>
                            <Link className={classes.linkWithIcon} href={`https://google.com/search?q=${contact ? contact.contact_first_name_other || toCustomTitleCase(contact.contact_first_name) : ''} ${contact ? toCustomTitleCase(contact.contact_last_name) : ''}${contact ? ', ' + capitalize(contact.current_companies) : ''}`} target='_blank' rel='noreferrer'>< OpenInNew /></Link>
                          </div>
                          {props.readOnly ?
                            <Button onClick={closeModal}>
                              <Close className={classes.buttonIcon} />
                            </Button>
                            :
                            <>{props.queueActions ?
                              (props.queueActions()) :
                              <div className={classes.modalButtonsContainer}>
                                {
                                  isActive ?
                                    <React.Fragment>
                                      {(props.adminUserSession.isSuperAdmin || props.adminUserSession.inHouseResearch) &&
                                        <Button color="primary" variant="contained" classes={{ label: classes.buttonLabel, root: classes.buttonMarginRight }} onClick={onRegenerateAiBio}>Regenerate Bio</Button>
                                      }
                                      <Button color="primary" variant="contained" classes={{ label: classes.buttonLabel, root: classes.buttonMarginRight }} onClick={onOpenNotes}>Notes</Button>
                                      <Button variant="outlined" classes={{ label: classes.buttonLabel, root: classes.buttonMarginRight }} onClick={openChangeLogs}>
                                        Changes
                                      </Button>
                                      <Button variant="outlined" classes={{ label: classes.buttonLabel, root: classes.buttonMarginRight }} onClick={markasReviewed}>
                                        Mark as Reviewed
                                      </Button>
                                    </React.Fragment> : ''
                                }
                                <HideEntity entityId={contact.id} entityType={"RiaContact"} entityHidden={isHidden} buttonProps={{ variant: "contained", classes: { label: classes.buttonLabel, root: classes.buttonMarginRight } }} />
                                <Button
                                  color="primary"
                                  variant="contained"
                                  type='submit'
                                  classes={{ label: classes.buttonLabel, root: classes.buttonMarginRight }}
                                  disabled={saving || validationsInProgress > 0 || hasValidationErrors}
                                >
                                  {saving ? <CircularProgress style={{ height: '25px', width: '25px' }} /> : validationsInProgress > 0 ? 'Validating...' : 'Save'}
                                </Button>

                                <Divider orientation="vertical" flexItem />

                                <Button onClick={closeModal}>
                                  <Close className={classes.buttonIcon} />
                                </Button>
                              </div>
                            }</>
                          }
                        </div>

                        <Divider className={classes.modalHeaderDivider} />

                        <div>
                          <Tabs
                            value={tab}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleTabChange}
                            aria-label="disabled tabs example"
                            variant="scrollable"
                            scrollButtons="on"
                          >
                            <Tab label="Contact Info" value={0} classes={{ wrapper: tab === 0 ? classes.tabSelected : classes.tab }} />
                            <Tab label="Education" value={1} classes={{ wrapper: tab === 1 ? classes.tabSelected : classes.tab }} />
                            <Tab label="Private Bio" value={2} classes={{ wrapper: tab === 2 ? classes.tabSelected : classes.tab }} />
                            <Tab label="Current Companies Data" value={20} classes={{ wrapper: tab === 20 ? classes.tabSelected : classes.tab }} />
                            <Tab label="Ai Dentified Data" value={21} classes={{ wrapper: tab === 21 ? classes.tabSelected : classes.tab }} />
                            {isOnlyResearcher ? '' : <Tab label="Employment" value={3} classes={{ wrapper: tab === 3 ? classes.tabSelected : classes.tab }} />}
                            {isOnlyResearcher ? '' : <Tab label="Employment - Broker" value={30} classes={{ wrapper: tab === 30 ? classes.tabSelected : classes.tab }} />}
                            {isOnlyResearcher ? '' :
                              [
                                <Tab label="General" value={4} key={'General'} classes={{ wrapper: tab === 4 ? classes.tabSelected : classes.tab }} />,
                                <Tab label="Company Info" value={5} key={'Info'} classes={{ wrapper: tab === 5 ? classes.tabSelected : classes.tab }} />,
                                <Tab label="Registrations" value={6} key={'Registrations'} classes={{ wrapper: tab === 6 ? classes.tabSelected : classes.tab }} />,
                                <Tab label="Disclosures" value={7} key={'Disclosures'} classes={{ wrapper: tab === 7 ? classes.tabSelected : classes.tab }} />,
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="Designations" value={8} key={'Designations'} classes={{ wrapper: tab === 8 ? classes.tabSelected : classes.tab }} /> : '',
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="General - Broker" value={40} key={'General-Broker'} classes={{ wrapper: tab === 40 ? classes.tabSelected : classes.tab }} /> : '',
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="Company Info - Broker" value={50} key={'Info-Broker'} classes={{ wrapper: tab === 50 ? classes.tabSelected : classes.tab }} /> : '',
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="Registrations - Broker" value={60} key={'Registrations-Broker'} classes={{ wrapper: tab === 60 ? classes.tabSelected : classes.tab }} /> : '',
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="Disclosures - Broker" value={70} key={'Disclosures-Broker'} classes={{ wrapper: tab === 70 ? classes.tabSelected : classes.tab }} /> : '',
                                entityType !== undefined && ['BD', 'DR'].includes(entityType) ? <Tab label="Designations - Broker" value={80} key={'Designations-Broker'} classes={{ wrapper: tab === 80 ? classes.tabSelected : classes.tab }} /> : '',
                                (contact.isOwner ? <Tab label="Owner/Executive Officer" value={10} key={'Officer'} classes={{ wrapper: tab === 10 ? classes.tabSelected : classes.tab }} /> : ''),
                                <Tab label="Warnings" value='warnings' key={'Warnings'} classes={{ wrapper: tab === 'warnings' ? classes.tabSelected : classes.tab }} />,
                                <Tab label="Data Integrity Warnings" value='data_integrity_warnings' key={'DataIntegrityWarnings'} classes={{ wrapper: tab === 'data_integrity_warnings' ? classes.tabSelected : classes.tab }} />,
                              ]
                            }
                          </Tabs>
                        </div>
                      </div>
                    }
                  />

                  <Divider />

                  <CardContent className={classes.cardContent}>
                    <ContactHeader
                      contact={contact}
                      handleRemovePhoto={handleRemovePhoto}
                      handleChangeFileInput={handleChangeFileInput}
                      diCurrentCount={diCurrentCount}
                      diTotalUniqueCount={diTotalUniqueCount}
                      fetchingDiWarnings={fetchingDiWarnings}
                      updatesAllTimeCount={updatesAllTimeCount}
                      updatesLast30DaysCount={updatesLast30DaysCount}
                      fetchingUpdateCounts={fetchingUpdateCounts}
                    />
                    <div className={classes.contentSection}>
                      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 0)}>
                        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 0 || tab === 1 || tab === 2 || tab === 20 ? classes.tabActive : ''}`}>General Contact Info</Typography>
                        {tab === 0 || tab === 1 || tab === 2 || tab === 20 ? <ExpandLess /> : <ExpandMore />}
                      </div>
                      <Collapse in={tab === 0 || tab === 1 || tab === 2 || tab === 20}>
                        <ContactInfo
                          contact={contact}
                          handleTabChange={handleTabChange}
                          handleFieldChange={handleContactFieldChange}
                          clearAiDentifiedPersonalEmail={() => handleAiDentifiedFieldChange({ target: { name: 'personal_email_address', value: '', type: 'text' } })}
                          hadleOpen={hadleOpen}
                          openTitleAutocomplete={openTitleAutocomplete}
                          openAutomatedTitleAutocomplete={openAutomatedTitleAutocomplete}
                          handleOpenNewTitleModal={handleOpenNewTitleModal}
                          handleOnChangeAutocomplete={handleOnChangeAutocomplete}
                          handleInputChangeAutocomplete={handleInputChangeAutocomplete}
                          openAchievementsAutocomplete={openAchievementsAutocomplete}
                          loadingAchievements={loadingAchievements}
                          tab={tab}
                          pastEmails={pastEmails}
                          potentialLinkedinUrl={potentialLinkedinUrl}
                          setHasFieldChanges={setHasFieldChanges}
                          emailValidations={emailValidations}
                          onInvestorsForDomainChange={(investors) => setInvestorsForDomain(investors)}
                          onInvestorsForDomainEmailFieldChange={(field) => setInvestorsForDomainEmailField(field)}
                          onValidationStart={() => setValidationsInProgress(prev => prev + 1)}
                          onValidationEnd={() => setValidationsInProgress(prev => prev - 1)}
                          onFieldError={handleFieldError}
                        />

                        {
                          contact.industryTenure.start && <IndustryTenure industryTenure={contact.industryTenure} handleTabChange={handleTabChange} tab={tab} />
                        }

                        <CurrentCompanyData
                          currentCompanyDataStatus={currentCompanyDataStatus}
                          currentCompanyData={currentCompanyData}
                          handleTabChange={handleTabChange}
                          tab={tab}
                          handleCompanyDataChange={handleCompanyDataChange}
                        />

                        <EducationSection
                          educationHistory={educationHistory}
                          tab={tab}
                          handleTabChange={handleTabChange}
                          statusRelationships={statusRelationships}
                          handleNestedFieldChange={handleNestedFieldChange}
                          handleRemoveNestedFields={handleRemoveNestedFields}
                          handleAddNestedFields={handleAddNestedFields}
                        />

                        <PrivateBio contact={contact} handleTabChange={handleTabChange} handleFieldChange={handleContactFieldChange} tab={tab} />
                      </Collapse>
                    </div>

                    <div className={classes.contentSection}>
                      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 21)}>
                        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 21 ? classes.tabActive : ''}`}>Ai Dentified Data</Typography>
                        {tab === 21 ? <ExpandLess /> : <ExpandMore />}
                      </div>
                      <Collapse in={tab === 21}>
                        <AiDentifiedData
                          aiDentifiedData={contact.aiDentifiedData}
                          handleTabChange={handleTabChange}
                          handleFieldChange={handleAiDentifiedFieldChange}
                          tab={tab}
                        />
                      </Collapse>
                    </div>

                    <div className={classes.contentSection}>
                      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 3)}>
                        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 3 || tab === 4 || tab === 5 || tab === 6 || tab === 7 || tab === 8 ? classes.tabActive : ''}`}>Investment Advisor Info </Typography>
                        {tab === 3 || tab === 4 || tab === 5 || tab === 6 || tab === 7 || tab === 8 ? <ExpandLess /> : <ExpandMore />}
                      </div>
                      <Collapse in={tab === 3 || tab === 4 || tab === 5 || tab === 6 || tab === 7 || tab === 8}>
                        {isOnlyResearcher ? '' :
                          <EmploymentContainer
                            tabNumber={3}
                            accordion={"investment"}
                            employmentHistory={employmentHistory}
                            setEmploymentHistory={setEmploymentHistory}
                            relationships={relationships}
                            handleTabChange={handleTabChange}
                            handleAddNestedFields={handleAddNestedFields}
                            tab={tab}
                            handleRemoveNestedFields={handleRemoveNestedFields}
                            handleNestedFieldChange={handleNestedFieldChange}
                            contactId={props.contactId}
                            itemType='IA'
                          />
                        }
                        {isOnlyResearcher ? '' :
                          <General
                            entityType='IA'
                            contact={contact}
                            tab={tab}
                            tabNumber={4}
                            handleTabChange={handleTabChange}
                            statusRelationships={statusRelationships}
                          />
                        }
                        {isOnlyResearcher ? '' :
                          <CompanyInfoContainer itemType='IA' tab={tab} tabNumber={5} handleTabChange={handleTabChange} contactId={props.contactId} />
                        }
                        {isOnlyResearcher ? '' :
                          <RegistrationsContainer itemType='IA' tab={tab} tabNumber={6} contactId={props.contactId} handleTabChange={handleTabChange} accordion={"investment"} />
                        }
                        {isOnlyResearcher ? '' :
                          <Disclosures disclosure={disclosureData} tab={tab} tabNumber={7} handleTabChange={handleTabChange} statusRelationships={statusRelationships} />
                        }
                        {isOnlyResearcher ? '' :
                          <DesignationsContainer itemType='IA' contact={contact} tabNumber={8} tab={tab} handleTabChange={handleTabChange} />
                        }
                      </Collapse>
                    </div>

                    <div className={classes.contentSection}>
                      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 30)}>
                        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 30 || tab === 40 || tab === 50 || tab === 60 || tab === 70 || tab === 80 ? classes.tabActive : ''}`}>Broker Dealer Info</Typography>
                        {tab === 30 || tab === 40 || tab === 50 || tab === 60 || tab === 70 || tab === 80 ? <ExpandLess /> : <ExpandMore />}
                      </div>
                      <Collapse in={tab === 30 || tab === 40 || tab === 50 || tab === 60 || tab === 70 || tab === 80}>
                        {isOnlyResearcher ? '' :
                          <EmploymentContainer
                            tabNumber={30}
                            employmentHistory={employmentHistoryBrokerDealer}
                            setEmploymentHistory={setEmploymentHistoryBrokerDealer}
                            handleTabChange={handleTabChange}
                            handleAddNestedFields={handleAddNestedFields}
                            tab={tab}
                            handleRemoveNestedFields={handleRemoveNestedFields}
                            handleNestedFieldChange={handleNestedFieldChange}
                            contactId={props.contactId}
                            itemType='BD'
                          />
                        }
                        {isOnlyResearcher ? '' :
                          <General
                            entityType='BD'
                            contact={contact}
                            tab={tab}
                            handleTabChange={handleTabChange}
                            tabNumber={40}
                            statusRelationships={statusRelationships}
                          />
                        }
                        {isOnlyResearcher ? '' :
                          <CompanyInfoContainer itemType='BD' tab={tab} handleTabChange={handleTabChange} tabNumber={50} contactId={props.contactId} />
                        }
                        {isOnlyResearcher ? '' :
                          <RegistrationsContainer itemType='BD' tab={tab} contactId={props.contactId} tabNumber={60} handleTabChange={handleTabChange} accordion={"broker"} />
                        }
                        {isOnlyResearcher ? '' :
                          <Disclosures disclosure={disclosureBrokerDealerData} tab={tab} handleTabChange={handleTabChange} tabNumber={70} statusRelationships={statusRelationships} />
                        }
                        {isOnlyResearcher ? '' :
                          <DesignationsContainer itemType='BD' contact={contact} tab={tab} tabNumber={80} handleTabChange={handleTabChange} />
                        }
                      </Collapse>
                    </div>

                    {isOnlyResearcher ? '' :
                      (contact.isOwner ?
                        <OwnerExecutiveOfficerContainer contactId={props.contactId} tab={tab} handleTabChange={handleTabChange} />
                        : '')
                    }

                    {isOnlyResearcher ? '' :
                      <ContactsAccoladesSectionContainer contact={contact} tab={tab} handleTabChange={handleTabChange} />
                    }

                    {isOnlyResearcher ? '' :
                      <ContactsForbesAumsSectionContainer contactCrdId={contact.contact_crd_id} tab={tab} handleTabChange={handleTabChange} />
                    }

                    {isOnlyResearcher ? '' :
                      <InvestmentCommitteeMember tab={tab} handleTabChange={handleTabChange} adminUserSession={props.adminUserSession} contactCrdId={contact.contact_crd_id} setHasUnsavedChanges={setHasUnsavedChanges} />
                    }

                    <WarningsSection
                      tab={tab}
                      handleTabChange={handleTabChange}
                      warnings={warnings}
                      setWarnings={setWarnings}
                      fetching={fetchingWarnings}
                      scroll={tab === 'warnings'}
                    />

                    <DataIntegrityWarningsSection
                      tab={tab}
                      handleTabChange={handleTabChange}
                      warnings={diWarnings}
                      fetching={fetchingDiWarnings}
                      scroll={tab === 'data_integrity_warnings'}
                    />

                  </CardContent>
                </React.Fragment>
            }

            {openNewTitleModal ? <AdminNewTitleContainer open={openNewTitleModal} onClose={handleCloseNewTitleModal} /> : ''}
          </form>
          {props.queueSidebar &&
            (props.queueSidebar(((status && status == 'updating') || (status && status != 'fetched'))))
          }
          <CustomSnackbar
            open={showSnackBar}
            closeHandler={handleCloseSnackBar}
            message={snackBarMessage}
            options={{
              severity: 'warning'
            }}
            stayOpen={snackBarMessage.toLowerCase().includes('is already in use')}
          />
        </Card>
      </Modal>

      {
        openChanges && (
          <ChangeLogModal open={openChanges} onClose={() => setOpenChanges(false)} changes={changes} changedBy={"FintrX Importer"} />
        )
      }

      <NotesDialog
        label={"Add a Note"}
        body={""}
        adminNotes={adminNotes}
      />

      <LinkedinSyncConfirmDialog {...linkedinConfirmDialogProps} />
      <LinkedinUnsyncWarningDialog {...linkedinUnsyncWarningDialogProps} />

      {
        snackbar.open ?
          <CustomSnackbar
            open={snackbar.open}
            closeHandler={snackbar.close}
            message={snackbar.message}
            options={{
              severity: 'success'
            }}
          />
          : null
      }
    </>

  );
}

export default EditContactModalRebuild;
